import React, { useEffect, useState, useContext } from "react";
import "./RamlJadval.css";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { ramlKey } from "../../data";
import HeaderB from "../../components/headerb/HeaderB";
import { Link } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";
import apiUrl from "../../utils/ApiConfig";
import NatijehLink from "../../utils/NatijehLink";

export default function RamlJadval() {
  let { zayech, vlue16 } = useContext(MainContext);

  const [ramlKeys, setRamlKeys] = useState(ramlKey);
  const [getFeatre, setGetFeatre] = useState([]);
  const mainContext = useContext(MainContext);

  const tafsirData = [
    { id: 0, value: "شرف" },
    { id: 1, value: "هبوط" },
    { id: 2, value: "امن" },
    { id: 3, value: "نکبت" },
    { id: 4, value: "عدد" },
    { id: 5, value: "مزاج" },
    { id: 6, value: "حروف" },
    { id: 7, value: "فرح" },
    { id: 8, value: "ترح" },
    { id: 9, value: "قوت" },
    { id: 10, value: "ضعف" },
    { id: 11, value: "حضیض" },
  ];
  const getFeature = () => {
    let obj = {
      value: vlue16,
      id: 0,
    };
    async function myApp() {
      const res = await fetch(`${apiUrl}/GetFeature`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          setGetFeatre(result);
        });
    }
    myApp();
  };
  useEffect(() => {
    getFeature();
  }, []);

  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <Row>
          <Col className="ramlpic-colmain" xs={12} lg={7}>
            <br /> <br /> <br /> <br /> <br /> <br />
            <div className="ramlpic-divimg2">
              <>
                <div className="ramlpic-div">
                  {zayech?.length == 0 ? (
                    <>
                      <div className="ramlcircle-loading ">
                        <br /> <br /> <br /> <br /> <br /> <br />
                        <div class="loading">
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                        </div>
                        <h1 className="ramlcircle-div2">درحال لود شدن</h1>
                      </div>
                    </>
                  ) : (
                    <div className="ramljadval1 ">
                      <div>
                        <>
                          {zayech?.length != 0 && (
                            // mainContext.flag !== false &&
                            <Col md={12} xl={12}>
                              <div className="table-responsive">
                                <table className="table-responsive table-bordered ramljadval2">
                                  <tbody>
                                    <tr key="">
                                      <th></th>
                                      {zayech?.map((item, index) => (
                                        <>
                                          <th>
                                            <div>
                                              <img className="ramljadval-imgapi" src={item.src} alt="" />
                                            </div>
                                          </th>
                                        </>
                                      ))}
                                    </tr>
                                    {tafsirData.map((item) => (
                                      <tr key="" className="ramljadval-tabe-tr">
                                        <td>
                                          <span>{item.value}</span>
                                        </td>

                                        {zayech?.map((cir, index) =>
                                          getFeatre.filter((filter) => filter.qua === item.value && filter.pos === index + 1).length != 0 ? (
                                            getFeatre
                                              .filter((filter) => filter.qua === item.value && filter.pos === index + 1)
                                              .map((ite) => (
                                                <td>
                                                  <img src="../../../../images/nazarat/qovat.png" alt="" />
                                                </td>
                                              ))
                                          ) : (
                                            <td>
                                              <img src="../../../../images/nazarat/zaaf.png" alt="" />
                                            </td>
                                          )
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          )}
                        </>
                      </div>
                    </div>
                  )}
                </div>
              </>
            </div>
          </Col>

          <Col xs={10} lg={1}></Col>
          <Col xs={10} lg={4}>
            <br />
            <br />
            <br />
            <br />
            <div center className="d-grid gap-2">
              <br />
              <br />

              <Link className="linkBtn" to="/ramlcircle">
                {" "}
                زایچه دوار{" "}
              </Link>
              <Link className="linkBtn" to="/ramlpic">
                {" "}
                زایچه درختواره{" "}
              </Link>
              <Link className="linkBtn" to="/RamlNazar">
                {" "}
                نظرات نجومی{" "}
              </Link>
              <NatijehLink style={true} />
              <br />
              <br />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
